export const GENERIC_REQUIRED_FIELD_MSG = 'A required field needs input.';
export const TOOLTIP_ERROR_LIST_CLASS = 'tooltip-error-list';
